import { render, staticRenderFns } from "./ReportingInsights.vue?vue&type=template&id=491d58ae&scoped=true"
import script from "./ReportingInsights.vue?vue&type=script&lang=js"
export * from "./ReportingInsights.vue?vue&type=script&lang=js"
import style0 from "./ReportingInsights.vue?vue&type=style&index=0&id=491d58ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d58ae",
  null
  
)

export default component.exports